import { Truck, Users } from 'lucide-react';
import { cn } from '@/lib/utils';

const TYPES = [
  {
    value: 'Company Driver',
    icon: Users,
    title: 'Company Driver',
    desc: 'You drive a company-provided truck. Paid per mile or percentage on a W-2 or 1099 basis.',
  },
  {
    value: 'Owner Operator',
    icon: Truck,
    title: 'Owner Operator',
    desc: 'You own your truck and trailer and haul under our authority as an independent contractor.',
  },
];

export default function StepDriverType({ selected, onSelect }) {
  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-lg font-semibold text-foreground">What are you applying as?</h2>
        <p className="text-sm text-muted-foreground mt-1">Select the option that best describes you.</p>
      </div>
      <div className="space-y-3 pt-1">
        {TYPES.map(({ value, icon: Icon, title, desc }) => (
          <button
            key={value}
            type="button"
            onClick={() => onSelect(value)}
            className={cn(
              'w-full text-left flex items-start gap-4 p-4 rounded-xl border transition-all duration-150',
              selected === value
                ? 'border-primary bg-primary/10 ring-1 ring-primary'
                : 'border-border bg-muted/40 hover:border-border hover:bg-white/5'
            )}
          >
            <div className={cn(
              'w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5',
              selected === value ? 'bg-primary/20' : 'bg-white/5'
            )}>
              <Icon className={cn('w-5 h-5', selected === value ? 'text-primary' : 'text-muted-foreground')} />
            </div>
            <div>
              <p className={cn('font-semibold text-sm', selected === value ? 'text-primary' : 'text-foreground')}>{title}</p>
              <p className="text-xs text-muted-foreground mt-0.5 leading-relaxed">{desc}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
